var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mb-2 pl-1 text-left"},[_c('span',{staticClass:"font-weight-bold"},[_vm._v("Tamanho: ")]),_vm._v(_vm._s(_vm._f("capitalize")(_vm.gr1desc)))])}
var staticRenderFns = []

export { render, staticRenderFns }